$(() => {
  const loaderDiv = $('<div>').attr('id', 'process-loader').attr('style', 'margin-left: auto; margin-right: auto;width: 171px;height: 41px;text-align: center;');
  const img = $('<img>').attr('src', '/img/purchase-spinner.gif').appendTo('body').css('display', 'none');

  $('button[type="submit"]').click(function (e) {
    const btn = $(this);
    const buttons = $('button[type="submit"]');

    buttons.not(btn).attr('disabled', true);

    loaderDiv.html(img);
    $(this).parent().append(loaderDiv);
    $(this).hide();
    img.show();
  });
});
